// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import ElementUI from 'element-ui';

import vuescroll from 'vuescroll';

import VueClipboard from 'vue-clipboard2'


import './assets/css/reset.css'
import './assets/css/theme.scss'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


import App from './App'
import router from './router'
import store from './store';
import './icons'

// import 'xe-utils'
// import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import * as api from './api';
import * as currency from './pages/utils';
import VueUeditorWrap from 'vue-ueditor-wrap'


Vue.component('vue-ueditor-wrap', VueUeditorWrap)
// Vue.use(VXETable)
Vue.use(vuescroll);
Vue.use(ElementUI);
Vue.use(VueQuillEditor);
Vue.use(VueClipboard);
Vue.config.productionTip = false
Vue.prototype.$api=api
Vue.prototype.$currency=currency
Vue.prototype.$bus=new Vue();//总线模式
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js